<template>
	<TheTable
		class="table__logs"
		:tableData="filteredLogs"
		:loading="loading"
		:defaultSort="{ prop: 'dateTime', order: 'descending' }"
		:show-header="false"
	>
		<el-table-column prop="dateTime" label="" width="160">
			<template #default="scope">
				<span>{{ $formatDate(scope.row.dateTime, 'DD.MM.YYYY HH:MM') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="" width="250">
			<template #default="scope">
				<span>{{ scope.row.firstName }} {{ scope.row.lastName }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="" label="" width="200">
			<template #default="scope">
				<span>{{ scope.row.roles.join(', ') }}</span>
			</template>
		</el-table-column>
		<el-table-column prop="affectedColumns" label="" :class-name="'cell--alignleft'">
			<template #default="scope">
				<span>{{ scope.row.affectedColumns }}</span>
			</template>
		</el-table-column>
	</TheTable>
</template>

<script lang="ts">
import TheTable from '../TheTable.vue';
import { AuditResponse } from '@/types/types';
import { translateAffectedColumns } from '@/utils/columnTranslations';

export default {
	name: 'LogsTable',
	data() {
		return {};
	},
	props: {
		logs: {
			type: Array as () => AuditResponse[],
			default: () => [],
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		filteredLogs() {
			return this.filterLogs(this.logs);
		},
	},
	methods: {
		filterLogs(logs: AuditResponse[]) {
			const filteredLogs = logs
				.filter((l) => l.changes && l.userId)
				.map((l) => {
					const affectedColumns = this.parseLogData(l.type, l.affectedColumns);
					return {
						...l,
						affectedColumns: affectedColumns,
					};
				});
			return filteredLogs;
		},
		parseLogData(type: string, data: string): string {
			try {
				if (!data) {
					return '';
				}
				let changes = JSON.parse(data);
				const columnTranslations = translateAffectedColumns(changes);
				let preText;
				if (type === 'Insert') {
					preText = 'Neue Einträge: ';
				} else if (type === 'Update') {
					preText = 'Veränderte Werte: ';
				} else {
					preText = 'Veränderte Werte: ';
				}
				let resultText = `${preText}${columnTranslations.join(', ')}`;
				return resultText;
			} catch (error) {
				console.error('Error parsing log data:', data, error);
				return data;
			}
		},
	},
	components: {
		TheTable,
	},
};
</script>

<style lang="scss">
.table__logs.el-table {
	.el-table__body {
		background-color: transparent !important;

		.el-table__row {
			height: 60px;
			.el-table__cell,
			.el-table__cell:first-child,
			.el-table__cell:last-child {
				border: 0px;
				vertical-align: top;
			}
		}
	}
}
</style>
